var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 190,
    height: 160,
    viewBox: "0 0 190 160",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.103 82.3878C171.103 124.533 136.936 158.7 94.7905 158.7C52.6449 158.7 18.4785 124.533 18.4785 82.3878C18.4785 40.2414 52.6449 6.07568 94.7905 6.07568C136.936 6.07568 171.103 40.2414 171.103 82.3878Z",
    stroke: "url(#paint0_linear_5505_1328)",
    strokeWidth: 2.56098
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0537 40.876H115.094C118.619 40.876 121.47 43.7344 121.47 47.252V78.212C121.47 81.7368 118.611 84.588 115.094 84.588H74.0537C70.5289 84.588 67.6777 81.7296 67.6777 78.212V47.252C67.6777 43.7344 70.5361 40.876 74.0537 40.876Z",
    fill: "white",
    stroke: "url(#paint1_linear_5505_1328)",
    strokeWidth: 2.56098
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.998 62.1958C95.99 62.1958 96.798 63.0038 96.798 63.9958C96.798 64.9878 95.99 65.7958 94.998 65.7958H84.798C83.806 65.7958 82.998 64.9878 82.998 63.9958C82.998 63.0038 83.806 62.1958 84.798 62.1958H94.998ZM105.198 62.1958C106.19 62.1958 106.998 63.0038 106.998 63.9958C106.998 64.9878 106.19 65.7958 105.198 65.7958H100.998C100.006 65.7958 99.198 64.9878 99.198 63.9958C99.198 63.0038 100.006 62.1958 100.998 62.1958H105.198ZM105.198 54.4038C106.19 54.4038 106.998 55.2118 106.998 56.2038C106.998 57.1958 106.19 58.0038 105.198 58.0038H84.798C83.806 58.0038 82.998 57.1958 82.998 56.2038C82.998 55.2118 83.806 54.4038 84.798 54.4038H105.198Z",
    fill: "url(#paint2_linear_5505_1328)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134.229 88.3601V88.3609V88.3617L126.677 119.322C125.98 122.18 123.42 124.188 120.477 124.188H69.0212C66.078 124.188 63.5188 122.18 62.8212 119.322L55.2692 88.3617C54.434 84.9369 56.5332 81.4889 59.958 80.6521C60.458 80.5369 60.9644 80.4761 61.4772 80.4761H128.037C131.562 80.4761 134.413 83.3345 134.413 86.8521C134.413 87.3577 134.352 87.8713 134.229 88.3601Z",
    fill: "white",
    stroke: "url(#paint3_linear_5505_1328)",
    strokeWidth: 2.56098
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.9973 95.2036H109.997C110.989 95.2036 111.797 96.0116 111.797 97.0036C111.797 97.9956 110.989 98.8036 109.997 98.8036H79.9973C79.0053 98.8036 78.1973 97.9956 78.1973 97.0036C78.1973 96.0036 79.0053 95.2036 79.9973 95.2036Z",
    fill: "url(#paint4_linear_5505_1328)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.8 110.196H102.2C103.192 110.196 104 111.004 104 111.996C104 112.988 103.192 113.796 102.2 113.796H87.8C86.808 113.796 86 112.988 86 111.996C86 111.004 86.808 110.196 87.8 110.196Z",
    fill: "url(#paint5_linear_5505_1328)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.8 110.196H102.2C103.192 110.196 104 111.004 104 111.996C104 112.988 103.192 113.796 102.2 113.796H87.8C86.808 113.796 86 112.988 86 111.996C86 111.004 86.808 110.196 87.8 110.196Z",
    fill: "url(#paint6_linear_5505_1328)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43044 65.7998H28.9584C32.2944 65.7998 34.9904 68.5038 34.9904 71.8318V93.3598C34.9904 96.6958 32.2864 99.3918 28.9584 99.3918H7.43044C4.09444 99.3918 1.39844 96.6878 1.39844 93.3598V71.8318C1.39844 68.5038 4.10244 65.7998 7.43044 65.7998Z",
    fill: "url(#paint7_linear_5505_1328)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42974 66.0801H28.9577C32.1385 66.0801 34.7097 68.6585 34.7097 71.8321V93.3601C34.7097 96.5409 32.1313 99.1121 28.9577 99.1121H7.42974C4.24894 99.1121 1.67773 96.5337 1.67773 93.3601V71.8321C1.67773 68.6585 4.25614 66.0801 7.42974 66.0801Z",
    fill: "white",
    stroke: "url(#paint8_linear_5505_1328)",
    strokeWidth: 2.56098
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.03 65.7998H182.558C185.894 65.7998 188.59 68.5038 188.59 71.8318V93.3598C188.59 96.6958 185.886 99.3918 182.558 99.3918H161.03C157.694 99.3918 154.998 96.6878 154.998 93.3598V71.8318C154.998 68.5038 157.702 65.7998 161.03 65.7998Z",
    fill: "url(#paint9_linear_5505_1328)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M161.029 66.0801H182.557C185.738 66.0801 188.309 68.6585 188.309 71.8321V93.3601C188.309 96.5409 185.731 99.1121 182.557 99.1121H161.029C157.849 99.1121 155.277 96.5337 155.277 93.3601V71.8321C155.277 68.6585 157.856 66.0801 161.029 66.0801Z",
    fill: "white",
    stroke: "url(#paint10_linear_5505_1328)",
    strokeWidth: 2.56098
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M178.679 81.3442L177.031 80.9362C176.935 80.6242 176.807 80.3202 176.647 80.0322C176.895 79.6162 177.415 78.7522 177.415 78.7522C177.511 78.5842 177.487 78.3762 177.351 78.2402L176.159 77.0482C176.023 76.9122 175.807 76.8882 175.647 76.9842L174.367 77.7522C174.079 77.6002 173.775 77.4722 173.463 77.3762L173.055 75.7282C173.007 75.5442 172.839 75.4082 172.647 75.4082H170.959C170.767 75.4082 170.599 75.5362 170.551 75.7282C170.551 75.7282 170.271 76.8802 170.143 77.3762C169.815 77.4802 169.487 77.6162 169.183 77.7842L167.855 76.9842C167.687 76.8882 167.479 76.9122 167.343 77.0482L166.151 78.2402C166.015 78.3762 165.991 78.5922 166.087 78.7522L166.911 80.1282C166.775 80.3922 166.671 80.6642 166.575 80.9442L164.927 81.3522C164.743 81.4002 164.607 81.5682 164.607 81.7602V83.4482C164.607 83.6402 164.735 83.8082 164.927 83.8562L166.583 84.2642C166.687 84.5842 166.815 84.8882 166.975 85.1842L166.239 86.4082C166.143 86.5762 166.167 86.7842 166.303 86.9202L167.495 88.1122C167.631 88.2482 167.847 88.2722 168.007 88.1762C168.007 88.1762 168.831 87.6802 169.239 87.4402C169.535 87.6002 169.839 87.7282 170.151 87.8242L170.559 89.4722C170.607 89.6562 170.775 89.7922 170.967 89.7922H172.655C172.847 89.7922 173.015 89.6642 173.063 89.4722L173.471 87.8242C173.799 87.7202 174.111 87.5842 174.407 87.4242C174.823 87.6722 175.655 88.1762 175.655 88.1762C175.823 88.2722 176.031 88.2482 176.167 88.1122L177.359 86.9202C177.495 86.7842 177.519 86.5682 177.423 86.4082L176.663 85.1442C176.815 84.8642 176.935 84.5602 177.031 84.2562L178.679 83.8482C178.863 83.8002 178.999 83.6322 178.999 83.4402V81.7602C178.999 81.5602 178.871 81.3922 178.679 81.3442ZM171.799 86.1442C169.847 86.1442 168.255 84.5522 168.255 82.6002C168.255 80.6482 169.847 79.0562 171.799 79.0562C173.751 79.0562 175.343 80.6482 175.343 82.6002C175.343 84.5522 173.751 86.1442 171.799 86.1442Z",
    fill: "url(#paint11_linear_5505_1328)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1912 80.7999C24.1912 80.6479 24.1352 80.4879 24.0232 80.3759L19.2232 75.5759C19.1112 75.4639 18.9512 75.4079 18.7992 75.4079V75.3999H15.1992C13.5432 75.3999 12.1992 76.7439 12.1992 78.3999V86.7999C12.1992 88.4559 13.5432 89.7999 15.1992 89.7999H21.1992C22.8552 89.7999 24.1992 88.4559 24.1992 86.7999L24.1912 80.7999ZM19.3992 77.4479L22.1512 80.1999H21.1992C20.2072 80.1999 19.3992 79.3919 19.3992 78.3999V77.4479ZM21.1992 88.5999H15.1992C14.2072 88.5999 13.3992 87.7919 13.3992 86.7999V78.3999C13.3992 77.4079 14.2072 76.5999 15.1992 76.5999H18.1992V78.3999C18.1992 80.0559 19.5432 81.3999 21.1992 81.3999H22.9992V86.7999C22.9992 87.7919 22.1912 88.5999 21.1992 88.5999ZM21.1992 86.1999C21.1992 86.5279 20.9272 86.7999 20.5992 86.7999H15.7992C15.4712 86.7999 15.1992 86.5279 15.1992 86.1999C15.1992 85.8719 15.4712 85.5999 15.7992 85.5999H20.5992C20.9272 85.5999 21.1992 85.8719 21.1992 86.1999ZM21.1992 83.7999C21.1992 84.1279 20.9272 84.3999 20.5992 84.3999H15.7992C15.4712 84.3999 15.1992 84.1279 15.1992 83.7999C15.1992 83.4719 15.4712 83.1999 15.7992 83.1999H20.5992C20.9272 83.1999 21.1992 83.4719 21.1992 83.7999ZM15.1992 81.3999C15.1992 81.0719 15.4712 80.7999 15.7992 80.7999H16.9992C17.3272 80.7999 17.5992 81.0719 17.5992 81.3999C17.5992 81.7279 17.3272 81.9999 16.9992 81.9999H15.7992C15.4712 81.9999 15.1992 81.7279 15.1992 81.3999Z",
    fill: "url(#paint12_linear_5505_1328)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9996 11.1999C97.982 11.1999 100.4 8.78222 100.4 5.7999C100.4 2.81758 97.982 0.399902 94.9996 0.399902C92.0172 0.399902 89.5996 2.81758 89.5996 5.7999C89.5996 8.78222 92.0172 11.1999 94.9996 11.1999Z",
    fill: "url(#paint13_linear_5505_1328)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9996 11.1999C97.982 11.1999 100.4 8.78222 100.4 5.7999C100.4 2.81758 97.982 0.399902 94.9996 0.399902C92.0172 0.399902 89.5996 2.81758 89.5996 5.7999C89.5996 8.78222 92.0172 11.1999 94.9996 11.1999Z",
    fill: "url(#paint14_linear_5505_1328)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5505_1328",
    x1: 94.7905,
    y1: 5.79568,
    x2: 94.7905,
    y2: 158.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5849FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5505_1328",
    x1: 94.5737,
    y1: 40.596,
    x2: 94.5737,
    y2: 84.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5849FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5505_1328",
    x1: 94.998,
    y1: 54.4038,
    x2: 94.998,
    y2: 65.7958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5849FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5505_1328",
    x1: 94.7492,
    y1: 80.1961,
    x2: 94.7492,
    y2: 124.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5849FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5505_1328",
    x1: 94.9973,
    y1: 95.2036,
    x2: 94.9973,
    y2: 98.8036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5849FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5505_1328",
    x1: 95,
    y1: 110.196,
    x2: 95,
    y2: 113.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5849FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5505_1328",
    x1: 95,
    y1: 110.196,
    x2: 95,
    y2: 113.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5849FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5505_1328",
    x1: 18.1944,
    y1: 65.7998,
    x2: 18.1944,
    y2: 99.3918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5849FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5505_1328",
    x1: 18.1937,
    y1: 65.8001,
    x2: 18.1937,
    y2: 99.3921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5849FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5505_1328",
    x1: 171.794,
    y1: 65.7998,
    x2: 171.794,
    y2: 99.3918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5849FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5505_1328",
    x1: 171.793,
    y1: 65.8001,
    x2: 171.793,
    y2: 99.3921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5849FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5505_1328",
    x1: 171.803,
    y1: 75.4082,
    x2: 171.803,
    y2: 89.7922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5849FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5505_1328",
    x1: 18.1992,
    y1: 75.3999,
    x2: 18.1992,
    y2: 89.7999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5849FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5505_1328",
    x1: 94.9996,
    y1: 0.399902,
    x2: 94.9996,
    y2: 11.1999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5849FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5505_1328",
    x1: 94.9996,
    y1: 0.399902,
    x2: 94.9996,
    y2: 11.1999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5849FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentManagement);
export default __webpack_public_path__ + "static/media/document-management.5e1175aeb0432db4d324e56efc87eb3c.svg";
export { ForwardRef as ReactComponent };